<!-- Breadcrumb -->
<div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
    <h5 class="mb-0">Developer Logs</h5>
    <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
        <li class="breadcrumb-item position-relative">Other</li>
        <li class="breadcrumb-item position-relative breadcrump-link">
            <a [routerLink]="['/others/developer-logs']">Developer Logs</a>
        </li>
        <li class="breadcrumb-item position-relative">LogDetails</li>
    </ol>
</div>
<button mat-icon-button  class="mb-3" (click)="goBackWithFilters()">
    <mat-icon>arrow_back</mat-icon>
</button>

<mat-card class="daxa-card recent-orders-card mb-25 border-radius bg-white border-none d-block log-container">
    <app-buffer-progress-bar *ngIf="isLoading"></app-buffer-progress-bar>

    <ng-container *ngIf="!isLoading">
        <div class="d-flex justify-content-between align-items-center log-title">
            <h2>
                <span class="severity-color" [style.background-color]="getSeverityColor(logDetails.severity)"></span>
                <span class="severity-text">{{ logDetails.severity }}</span>
            </h2>
            <div class="d-flex align-items-center log-id">
                <span>#{{ logDetails.id }}</span>
                <button mat-icon-button matTooltip="Copied!" #tooltip="matTooltip" [matTooltipDisabled]="true"
                    (click)="copyToClipboard(logDetails.id, tooltip)">
                    <mat-icon>content_copy</mat-icon>
                </button>
            </div>
        </div>

        <div class="log-details">
            @if(logDetails.timestamp){
            <p>{{ logDetails.timestampStr }}</p>
            }
            @if(logDetails.method){
            <p><b>Method:</b> {{ logDetails.method }}</p>
            }
            @if(logDetails.traceId){
            <p><b>TraceID:</b> {{ logDetails.traceId }}</p>
            }
            @if(logDetails.spandId){
            <p><b>SpandID:</b> {{ logDetails.spandId }}</p>
            }
            @if(logDetails.msg){
            <p><b>Message:</b> {{ logDetails.msg }}</p>
            }
            @if(logDetails.requestPath){
            <p><b>Request Path:</b> {{ logDetails.requestPath }}:{{ logDetails.lineNumber }}:{{ logDetails.columnNumber
                }}</p>
            }
            @if(logDetails.sourceContext){
            <p><b>Source Context:</b> {{ logDetails.sourceContext }}</p>
            }
            @if(logDetails.logEvent){
            <div class="d-flex justify-content-between align-items-center">
                <p>
                    <b>Log Event:</b>
                </p>
                <button mat-icon-button matTooltip="Copied!" #logEventTooltip="matTooltip" [matTooltipDisabled]="true"
                    (click)="copyLogEvent(logDetails.logEvent, logEventTooltip)">
                    <mat-icon>content_copy</mat-icon>
                </button>
            </div>
            <ace-editor [text]="formattedJson(logDetails.logEvent)" [mode]="'json'" [theme]="'monokai'"
                [readOnly]="true" [autoUpdateContent]="true"
                style="min-height: 300px; width: 100%; font-size: 14px; font-family: Outfit;">
            </ace-editor>
            }
        </div>
    </ng-container>
</mat-card>